<template>
	<main ref="main" role="main" class="exhibition" id="myContainer">
		<!-- <section class="exImgContainer"> -->
		<article class="mainText" id="my-sticky-element">
			<header>
				<div>
					<h1 class="headerItem" v-html="page.title"></h1>
					<p v-if="!nodate" class="headerItem">{{ exhibitionDates.string }}</p>
				</div>
			</header>
			<section class="artists">
				<!-- <p v-html="page.artist"></p> -->
				<p v-html="artists"></p>
				<!-- <p>{{artists}}</p> -->
			</section>
			<!-- <section class="runningText" v-html="page.descriptiontextarea"></section> -->
			<div
				v-if="noreadmore"
				class="runningText"
				v-html="page.descriptiontextarea"
			></div>
			<read-more
				v-if="!noreadmore"
				:class="'runningText'"
				more-str="read more"
				:text="page.descriptiontextarea"
				less-str="read less"
				:max-chars="650"
			></read-more>

			<!-- <section class="runningText" v-html="page.descriptiontextarea"></section> -->

			<section class="credits" ref="credits">
				<div v-if="!nodate">
					<!-- <h2 v-if="exhibitionDates.oneDay">Opening</h2> -->
					<!-- <h2 v-else>Vernissage</h2> -->
					<p>Vernissage: {{ vernissage }}, {{ page.vernissagehours }}</p>
				</div>
				<div v-if="!exhibitionDates.oneDay && !nodate">
					<!-- <h2>Finissage</h2> -->
					<p>Finissage: {{ finissage }}, {{ page.finissagehours }}</p>
				</div>
				<div>
					<!-- <h2>Open hours</h2> -->
					<p>Open hours: {{ infos.opendays }} {{ infos.openhours }}</p>
				</div>
				<!-- <div>
					<h2>{{ infos.name }}</h2>
					<p>
						{{ infos.address }}<br />
						{{ infos.npa }} {{ infos.locality }}
					</p>
				</div> -->
				<!-- <div class="more" v-html="page.more"></div> -->
				<vue-markdown
					:class="'more'"
					:source="page.more"
				></vue-markdown>
			</section>
		</article>
		<!-- <div id="trigger1"></div> -->
		<div class="mediaContainer" v-for="file in page.files" :key="file.uid">
			<img
				:src="file.url"
				v-if="!file.url.includes(page.imghero) && file.type === 'image'"
				alt=""
			/>
			<video
				class="videoInteractive"
				v-if="
					!file.url.includes(page.imghero) &&
						file.type === 'video' &&
						file.name.startsWith('audio-')
				"
				@click="toggleMute($event)"
				playsinline
				autoplay
				muted
				loop
			>
				<!-- <source :src="file.url.replace(file.extension, '') + 'webm'" :type="'video/webm'" /> -->
				<!-- <source :src="file.url.replace(file.extension, '') + 'mp4'" :type="'video/mp4'" /> -->
				<source :src="file.url" :type="file.mime" />
			</video>
			<span
				class="videoMute is-active"
				v-if="
					!file.url.includes(page.imghero) &&
						file.type === 'video' &&
						file.name.startsWith('audio-')
				"
				>unmute video</span
			>
			<video
				v-else-if="!file.url.includes(page.imghero) && file.type === 'video'"
				playsinline
				autoplay
				muted
				loop
			>
				<source :src="file.url.replace(file.extension, '') + 'webm'" :type="'video/webm'" />
				<source :src="file.url.replace(file.extension, '') + 'mp4'" :type="'video/mp4'" />
				<!-- <source :src="file.url" :type="file.mime" /> -->
			</video>
		</div>

		<!-- </section> -->
	</main>
</template>

<script>
import VueMarkdown from 'vue-markdown';
// import ScrollMagic from 'scrollmagic'

export default {
	name: 'exhibition',
	props: ['uid'],
	components: {
		VueMarkdown,
	},
	metaInfo() {
		return {
			title: this.title,
		};
	},
	computed: {
		artists() {
			let page = this.$store.getters.getPageByID('exhibitions/' + this.uid);
			let artists = page.artist;

			artists = artists.split(',');

			let artistsString = '';
			artists.forEach((el, i) => {
				if (i < artists.length - 1) {
					// artistsString += el + '&#8201;✳&#8201;'
					artistsString += el + ', ';
				} else {
					artistsString += el;
				}
			});

			return artistsString;
		},
		// exhibitionDates() {
		// 	let page = this.$store.getters.getPageByID('exhibitions/' + this.uid);
		// 	let begining = new Date(page.begining);
		// 	let end;
		// 	let endString;
		// 	let string = '';
		// 	let isOneDay = true;

		// 	// let beginingSting = begining.toLocaleString('en-gb', { month: 'short' }) + '. ' + begining.getDate()
		// 	let beginingSting =
		// 		begining.toLocaleString('en-gb', { month: 'long' }) +
		// 		' ' +
		// 		begining.getDate(); //WALLSTREET

		// 	if (page.end) {
		// 		end = new Date(page.end);
		// 		isOneDay = false;
		// 		// endString = end.toLocaleString('en-gb', { month: 'short' }) + '. ' + end.getDate();
		// 		endString =
		// 			end.toLocaleString('en-gb', { month: 'long' }) + ' ' + end.getDate(); //WALLSTREET
		// 		string =
		// 			begining.getFullYear() === end.getFullYear()
		// 				? beginingSting + '–' + endString + ', ' + end.getFullYear()
		// 				: beginingSting +
		// 				  ', ' +
		// 				  begining.getFullYear() +
		// 				  '–' +
		// 				  endString +
		// 				  ', ' +
		// 				  end.getFullYear();
		// 	} else {
		// 		string = beginingSting + ', ' + begining.getFullYear();
		// 	}
		// 	return { string: string, oneDay: isOneDay };
		// },
		exhibitionDates() {
			let page = this.$store.getters.getPageByID('exhibitions/' + this.uid);
			let begining = new Date(page.begining);
			let end;
			let endString;
			let string = '';
			let isOneDay = true;
			if (page.end) end = new Date(page.end);

			// let beginingSting = begining.toLocaleString('en-gb', { month: 'short' }) + '. ' + begining.getDate()
			// let endString = end.toLocaleString('en-gb', { month: 'short' }) + '. ' + end.getDate()

			let beginingSting =
				('0' + begining.getDate()).slice(-2) +
				'.' +
				('0' + (begining.getMonth() + 1)).slice(-2);
			if (page.end) {
				isOneDay = false;
				endString =
					('0' + end.getDate()).slice(-2) +
					'.' +
					('0' + (end.getMonth() + 1)).slice(-2);

				string = begining.getFullYear() === end.getFullYear()
					? beginingSting + '–' + endString + ',' + end.getFullYear()
					: beginingSting +
							'.' +
							begining
								.getFullYear()
								.toString()
								.substr(-2) +
							'–' +
							endString +
							'.' +
							end
								.getFullYear()
								.toString()
								.substr(-2);
			} else {
				string = beginingSting + ',' + begining.getFullYear();
			}
			return { string: string, oneDay: isOneDay }
		},
		vernissage() {
			let page = this.$store.getters.getPageByID('exhibitions/' + this.uid);
			let vernissage = new Date(page.vernissage);

			return (
				('0' + vernissage.getDate()).slice(-2) +
				'.' +
				('0' + (vernissage.getMonth() + 1)).slice(-2) +
				'.' +
				vernissage.getFullYear().toString().substr(-2)
			);
		},
		finissage() {
			let page = this.$store.getters.getPageByID('exhibitions/' + this.uid);
			let finissage = new Date(page.finissage);

			return (
				('0' + finissage.getDate()).slice(-2) +
				'.' +
				('0' + (finissage.getMonth() + 1)).slice(-2) +
				'.' +
				finissage.getFullYear().toString().substr(-2)
			);
		},
		nodate() {
			let page = this.$store.getters.getPageByID('exhibitions/' + this.uid);
			let nodate = page.isexception;
			if (!page.isexception) {
				return false;
			}
			let isnodate = false;
			if (nodate.includes('nodate')) isnodate = true;
			return isnodate;
		},
		noreadmore() {
			let page = this.$store.getters.getPageByID('exhibitions/' + this.uid);
			let noreadmore = page.isexception;
			if (!page.isexception) {
				return false;
			}
			let isnoreadmore = false;
			if (noreadmore.includes('noreadmore')) isnoreadmore = true;
			return isnoreadmore;
		},
		page() {
			return this.$store.getters.getPageByID('exhibitions/' + this.uid);
		},
		infos() {
			return this.$store.getters.getPageByUID('infos');
		},
	},
	methods: {
		removeWrapper(string) {
			let credits = this.$refs.credits;

			let newstringreplaced = string.replace(/<h2/gi, ',<h2');
			newstringreplaced = newstringreplaced.replace(/<h1/gi, ',<h1');
			let newstring = newstringreplaced.split(',');

			newstring.shift();

			let newHtml = '';

			newstring.forEach((el) => {
				newHtml += '<div class="more">' + el + '</div>';
			});

			credits.insertAdjacentHTML('beforeend', newHtml);

			return;
			// return newHtml
		},
		unmute() {
			this.muted = false;
		},
		mute() {
			this.muted = true;
		},
		toggleMute(event) {
			let vid = event.currentTarget;
			if (vid.muted) {
				vid.muted = false;
				vid.nextSibling.classList.remove('is-active');
			} else {
				vid.muted = true;
				vid.nextSibling.classList.add('is-active');
			}
		},
	},
	mounted() {
		// 			var controller = new ScrollMagic.Controller({container: "#myContainer"})

		// // create a scene
		// var scene = new ScrollMagic.Scene({triggerElement: "#trigger1", offset: -window.innerHeight/4}).setPin("#my-sticky-element").addTo(controller)
		// 		// var scene = new ScrollMagic.Scene({triggerElement: "#trigger1", duration: 300})
		// 		// 				.setPin("#pin1")
		// 		// 				.addIndicators({name: "1 (duration: 300)"}) // add indicators (requires plugin)
		// 		// 				.addTo(controller);$
		this.$refs.main.focus();
	},
	created() {
		let page = this.$store.getters.getPageByID('exhibitions/' + this.uid);
		console.log(page.files);
		if (!page) {
			this.$router.replace('/');
		}
	},
	data() {
		return {
			title: this.$store.getters.getPageByID('exhibitions/' + this.uid).title,
		};
	},
};
</script>

<style lang="scss">
@import './../assets/styles/general/mixins';
@import './../assets/styles/config';

.videoMute {
	font-size: 3em;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: block;
	visibility: hidden;
	pointer-events: none;
	z-index: 999999;
	color: white;
	text-shadow: 0em 0.02em 0.19em rgba(0, 0, 0, 0.4);
	&.is-active {
		visibility: visible;
	}
}
.exhibition {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	overflow-x: hidden;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	@include fluid-type(400px, 1300px, 5.888888888px, 12px);
	::-moz-selection {
		/* Code for Firefox */
		color: transparent; // text-shadow: 0px 0px 3px black, 0px 0px 9px black, 0px 0px 15px black;
		// text-shadow: 0px 0px 0.25rem black, 0px 0px 0.75rem black, 0px 0px 1.25rem black;
		text-shadow: 0px 0px 0.1em black;
	}

	::selection {
		color: transparent; // text-shadow: 0px 0px 3px black, 0px 0px 9px black, 0px 0px 15px black;
		// text-shadow: 0px 0px 0.25rem black, 0px 0px 0.75rem black, 0px 0px 1.25rem black;
		text-shadow: 0px 0px 0.1em black;
	}
	.mediaContainer {
		position: sticky;
		top: 0;
		@media screen and (max-width: $mq-tablet) {
			position: relative;
			margin-top: 2px; //WALLSTREET
		}
	}
	img,
	video {
		max-height: 100vh;
		max-height: var(--vh);
		width: 100vw;
		position: sticky;
		top: 0;
		display: block;
		margin: 0 auto;
		padding: 0;
		line-height: 0;
		object-fit: contain;
		object-position: 50% 0;
		box-sizing: border-box;
		outline: none;
		&:focus {
			outline: none;
			border: 0;
		}
		&.videoInteractive {
			cursor: pointer;
		}
		@media screen and (max-width: $mq-tablet) {
			height: auto;
			max-height: auto;
			max-width: auto;
			position: static;
			width: 100%;
		}
	}
}

.mainText {
	// position: sticky;
	// top: -100vh;
	// bottom: 0px;
	// top: 0;
	// overflow-y: auto;
	// -webkit-overflow-scrolling: touch;
	padding: 1.6em 1.6em;
	@include fluid-type(350px, 1400px, 5px, 12px);
	@media screen and (max-width: $mq-phone) {
		position: static;
		max-height: auto;
	}

	header {
		h1 {
			&:after {
				content: ', ';
			}
		}
		h1,
		h2,
		p {
			// font-size: 3.25rem;
			// font-size: 3.5rem;
			font-size: 1.4rem; //WALLSTREET
			font-family: Arial;
			font-weight: bold;
			// padding-right: 1em;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			line-height: 1.2;
			font-variant-numeric: tabular-nums;
			display: inline;
					@media screen and (max-width: 600px) {
			font-size: 1.2rem;
		}
		}
		margin-bottom: 0.7em;
		div {
			// width: 100%;
			width: 100%; //WALLSTREET
			flex-grow: 1;
			// display: flex;
			//min-width: 55em;
		}
	}
	.runningText {
		font-size: 1.4rem;
		margin-top: 1.2em;
		margin-bottom: 1.2em;
		max-width: 50%;
		@media screen and (max-width: $mq-tablet) {
			max-width: 100%;
		}
				@media screen and (max-width: 600px) {
			font-size: 1.2rem;
		}
		p {
			// font-size: 3.5rem;
			font-size: 1em;
			line-height: 1.2;
			hyphens: auto;
			font-family: Arial;
			font-weight: bold;
		}
		p {
			margin-bottom: 0.6em;
		}
		a {
			font-family: Arial;
			font-weight: bold;
		}
		blockquote {
			font-size: 1em;
			// font-style: italic;
			position: relative;
			margin-bottom: 0.6em;
			font-family: Arial;
			font-weight: bold;
			p {
				margin: 0;
				margin-left: 1.5em;
			}
			&:before {
				content: '"';
				font-size: 1em;
				position: absolute;
				// left: 0;
				// top: 0;
			}
		}
		em {
			font-style: italic;
		}
		ol,
		ul {
			// margin-left: 1em;
			line-height: 1.2;
			font-size: 1em;
			list-style-position: inside;
			list-style: none;
			margin-bottom: 0.6em;
			margin-left: 1.5em;
			font-family: Arial;
			font-weight: bold;
			li {
				position: relative;
				hyphens: auto;
				font-family: Arial;
				font-weight: bold;
				&:before {
					position: absolute;
					top: 0;
					left: -1.5em;
				}
			}

			// margin-left: 2em;
		}
		ol {
			li {
				counter-increment: step-counter;
				&:before {
					content: counter(step-counter);
					font-variant-numeric: tabular-nums;
				}
			}
		}
		ul {
			li {
				&:before {
					content: '⦿';
					text-transform: uppercase;
				}
			}
		}
	}

	.artists {
		font-size: 5em;
				@media screen and (max-width: 1450px) {
			font-size: 4.5em;
		}
		@media screen and (max-width: $mq-tablet) {
			font-size: 5em;
		}
		p {
			margin-bottom: 0.6em;
			font-size: 1em;
			line-height: 1;
			max-width: 50%;
							@media screen and (max-width: $mq-tablet) {
								max-width: 100%;
							}
		}
	}
	.more {
		margin-top: 1em;
		p {
			margin-bottom: 1em;
		}
		a {
			font-family: Arial;
    		font-weight: bold;
		}
	}
}

// .exImgContainer {

// }

.headerItem {
	// text-transform: uppercase;
	// text-transform: capitalize;
	// margin-bottom: 0.5em;
}

.credits {
	// margin-top: 2rem;
	@include fluid-type(400px, 1300px, 11.666666px, 12px);
	// margin-top: 2em;
	// padding-bottom: 6rem;
	margin-bottom: 6em;
	// justify-content: left;
	flex-wrap: wrap;
	// font-size: 12px;
	@media screen and (max-width: $mq-tablet) {
		// margin-top: 1em;
		margin-bottom: 2em;
		@include fluid-type(400px, 1300px, 5.888888888px, 12px);
	}
	div {
		// margin-top: 2rem;
		// margin-bottom: 1.2em;
		// flex-grow: 0;
		// flex-shrink: 0;
		// width: 25%;
		// min-width: 15em;
		// min-width: 16em;
		// margin-right: auto;
		@media screen and (max-width: $mq-tablet) {
			// flex-basis: 100%;
			// margin-top: 1em;
		}
		// @media screen and (max-width: $mq-phone) {
		// flex-basis: 100%;
		// margin-top: 1em;
		// }
	}
	p {
		// margin-top: 2rem;
		font-size: 1.4rem; //WALLSTREET
		line-height: 1.2;
		font-family: Arial;
		font-weight: bold;
				@media screen and (max-width: 600px) {
			font-size: 1.2rem;
		}
	}
	h2 {
		font-size: 1.4rem; //WALLSTREET
		// text-transform: uppercase;
		line-height: 1.2;
		font-family: Arial;
		font-weight: bold;
				@media screen and (max-width: 600px) {
			font-size: 1.2rem;
		}
	}
}

.galleryContainer {
	position: absolute;
	display: none;
	min-height: 100vh;
	min-height: var(--vh);
	width: 100%;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	& > section {
		height: 25vw;
		display: flex;
		flex-wrap: nowrap;
		div {
			width: 25%;
			height: 100%;
			span {
				border-radius: 100%;
				height: 100%;
				border: 1px solid black;
				text-align: center;
				justify-content: center;
				display: flex;
				align-content: center;
				align-items: center;
				font-size: 3.5rem;
			}
		}
	}
}
</style>
